import { AuthActionTypes, AuthState } from './auth.types';

export const LOGIN: AuthActionTypes = 'LOGIN';
export const SIGNOUT: AuthActionTypes = 'SIGNOUT';
export const FORGOT_PASSWORD: AuthActionTypes = 'FORGOT_PASSWORD';
export const DIFFERENT_ACCOUNT_LOGIN: AuthActionTypes = 'DIFFERENT_ACCOUNT_LOGIN';
export const SAME_ACCOUNT_LOGIN: AuthActionTypes = 'SAME_ACCOUNT_LOGIN';
export const EMAIL_OR_PWD_INCORRECT = 'Email or password is incorrect';

export const initialAuthState: AuthState = {
  authToken: '',
  statusCode: 0,
  email: '',
  differentAccountLogin: false
};


// WEBPACK FOOTER //
// ./src/auth/auth.constants.tsx